import { Component, Input, OnChanges } from '@angular/core';
import { MonDataPrivacyInfoTypeIconService } from './info-type-icon.service';

@Component({
    selector: 'mon-data-privacy-info-type-icon',
    templateUrl: './info-type-icon.component.html',
    standalone: false,
})
export class MonDataPrivacyInfoTypeIconComponent implements OnChanges {
    @Input() monTooltipText: string = '';
    @Input() monPriority: string = '';
    @Input() monGroup: string = '';

    colorClass: string = '';
    iconClass: string = '';

    constructor (private infoTypeIconService: MonDataPrivacyInfoTypeIconService) {}

    ngOnChanges (): void {
        this.iconClass = this.infoTypeIconService.getIcon(this.monGroup);
        this.colorClass = this.infoTypeIconService.getColor(this.monPriority);
    }
}
